/* eslint-disable guard-for-in */
import _ from 'lodash';
import Vue from 'vue';
import { Constants } from '@/constants';
import { engine } from '@/engine';
import bus from '@/events';

export function warn(key, message) {
  if (_.isUndefined(key)) {
    console.warn(message); // eslint-disable-line
  }
}

export function sendGAView(obj) {
  window.ga('send', obj);
}

export function findInvestmentOptions(exclude = ['Custom']) {
  return _.chain(engine.params.getParamObject('InvestmentOptions').list)
    .filter(option => _.indexOf(exclude, option.name) === -1)
    .sortBy(option => option.grossReturn);
}

export function findLowestInvestmentOption(exclude) {
  return _.first(findInvestmentOptions(exclude).value());
}

export function findHighestInvestmentOption(exclude) {
  return _.last(findInvestmentOptions(exclude).value());
}

export function calculateClosestTaxableIncome(grossReturn) {
  let taxableIncome = 1;
  let calculatedMultiplier = 0;
  const investmentOptionsList = engine.params.getParamObject('InvestmentOptions').list;
  // console.log('InvestmentOptions', investmentOptionsList);
  // eslint-disable-next-line no-restricted-syntax
  for (const optionList in investmentOptionsList) {
    const option = investmentOptionsList[optionList];
    if (option.name.indexOf('User') === -1) {
      if (grossReturn <= option.grossReturn) {
        calculatedMultiplier = option.taxableFraction / option.grossReturn;
        taxableIncome = Math.floor((grossReturn * calculatedMultiplier) * 10000) / 10000;
        break;
      }
    }
  }
  return taxableIncome;
}

export function get(state, key) {
  const value = _.get(state, `${key}`);

  warn(value, `get(${key}) - value not found`);

  return value;
}

export function getValue(state, key, defaultValue) {
  return _.get(get(state, `${key}`), 'value', defaultValue);
}

export function beforeSet(state, value, prop, args = {}) {
  const property = _.isString(prop) ? get(state, prop) : prop;
  warn(property, 'beforeSet - function not found');

  const valueToUse = _.isUndefined(args.overrideValue) ? value : args.overrideValue;
  return property.beforeSet(state, valueToUse, property, args);
}

export function afterSet(state, prop, args = {}) {
  const property = _.isString(prop) ? get(state, prop) : prop;
  warn(property, 'afterSet - function not found');

  const valueToUse = _.isUndefined(args.overrideValue) ? property.value : args.overrideValue;
  return property.afterSet(state, valueToUse, property, args);
}

export function set(state, data) {
  const { key } = data;
  let { value } = data;
  const options = data.options ? data.options : {};
  const args = data.args ? data.args : {};

  const property = get(state, key);
  const settings = _.defaultsDeep(options, {
    skipBeforeSet: false,
    skipAfterSet: false,
    propertyKey: 'value',
  });

  warn(property, `set(${key}) - value not found`);
  if (_.isFunction(property.beforeSet) && !settings.skipBeforeSet) {
    value = beforeSet(state, value, property, args);
  }

  _.set(state, _.concat(key, settings.propertyKey).join('.'), value);

  if (_.isFunction(property.afterSet) && !settings.skipAfterSet) {
    afterSet(state, property, args);
  }

  Vue.nextTick(() => {
    bus.$emit('resize');
  });
}

// Sometimes the value can come from the event instead of directly
// this will just get the value for both cases
export function evaluate(args, type = 'number') {
  const val = args.target ? args.target.value : args;

  if (type === 'boolean') {
    return JSON.parse(val);
  } if (!_.isEmpty(type)) {
    return _[_.camelCase(`to-${type}`)](val);
  }

  return val;
}

// Calls the value if it's a function or returns it
export function fnRun(state, args) {
  // The mutations only have access to state and the components access the store so we have to take the state!
  if (_.isFunction(args)) return args.call(state);
  return args;
}

// Makes it easier to call funstions without knowing about modifiers
export function curry(fn, modifier = Constants.PARAMETER_SUBJECT_SUFFIX) {
  return _.curry(fn)(modifier);
}

export function curryPartner(fn) {
  return curry(fn, Constants.PARAMETER_PARTNER_SUFFIX);
}
